export default __webpack_public_path__ + "static/media/admin-logo-less.9db36441.svg";